export function useBeta() {
  function isBeta(): boolean {
    const betaEnvironments = [
      'localhost',
      'beta',
      'ifinger',
      'penegal',
      'seceda',
      'vermoi',
    ];
    const url = window.location.href;
    return betaEnvironments.some((env) => url.includes(env));
  }
  return { isBeta };
}
